import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=13a8a9fb&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=13a8a9fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a8a9fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13a8a9fb')) {
      api.createRecord('13a8a9fb', component.options)
    } else {
      api.reload('13a8a9fb', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=13a8a9fb&scoped=true&", function () {
      api.rerender('13a8a9fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iBD7Wmt8UMNZ/JS/comp/DateRangeExt.vue"
export default component.exports